import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import EventsTheatreItemForm from "./EventsTheatreItemForm";
import EventsTheatreItemBrowser from "./EventsTheatreItemBrowser";

const EventsTheatrePage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="event"
            modeApiName2="events"
            ItemBrowserComponent={EventsTheatreItemBrowser}
            browserStyle={{width: "min(35%, 460px)", minWidth: "310px"}}
            browserFilterExtraParams={{kultural_goals: "theatre", filter_mode:"all"}}
            pageOptions={{kultural_goal: "theatre"}}
            ItemFormComponent={EventsTheatreItemForm}
        />
    );
};

export default EventsTheatrePage;